
import { Component, Prop, Vue } from "vue-property-decorator";

export enum TypeModal {
  "DEFAULT" = "default",
  "LARGE" = "large",
}

@Component({
  components: {},
})
/** `v-model`-driven modal dialog wrapper (fade transition), content passed via default slot. */
export default class Modal extends Vue {
  /** Whether the modal is shown. */
  @Prop({ required: true }) value!: boolean;
  @Prop({ default: TypeModal.DEFAULT }) type?: TypeModal;
}
